import { usePage } from "@inertiajs/react"
import React from "react"
import { IntercomDisabledAlert } from "./components/intercom-disabled-alert"
import { AdwordsConversionScript } from "./scripts/adwords-conversion"

/**
 * InertiaPageFooter renders layout elements that should appear after the main content.
 * This includes bottom alerts, conversion tracking scripts, and modals.
 *
 */
export function InertiaPageFooter() {
  const {
    props: { layoutConfig }
  } = usePage()

  return (
    <>
      {layoutConfig.components.intercomDisabledAlert.visible && (
        <IntercomDisabledAlert />
      )}

      {layoutConfig.components.adwordsScript.visible && (
        <AdwordsConversionScript
          {...layoutConfig.components.adwordsScript.data}
        />
      )}
    </>
  )
}
